module.exports = __webpack_public_path__ + "static/profile-d5d57f9f15a8a867e5f97b57338ffde8.png";